var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRight = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9961 17.3072L15.9961 2.38641C15.9961 2.00365 16.3064 1.69336 16.6891 1.69336C17.0719 1.69336 17.3822 2.00365 17.3822 2.38641L17.3822 17.3072C17.3822 17.6898 17.0717 18.0003 16.6891 18.0003C16.3066 18.0003 15.9961 17.6898 15.9961 17.3072Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5553 10.502L2.75 10.502C2.33579 10.502 2 10.1662 2 9.75195C2 9.33774 2.33579 9.00195 2.75 9.00195L11.5553 9.00195L11.5553 6.75195L14.5478 9.75195L11.5553 12.752L11.5553 10.502Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/right.8d0bc27e.svg";
export { ForwardRef as ReactComponent };